<template>
  <div class="SectionTitle d-flex justify-space-between align-center">
    <div>
      <div class="SectionTitle-child">
        <div
          v-if="category !== ''"
          class="category-box"
        >
          <img :src="'./assets/icons/square-' + category + '.png'" />
        </div>
        <div
          class="app-color-1"
          :class="titleClass"
        >
          {{ title }}
        </div>
        <div v-if="showHelp">
          <v-img
            src="@/assets/icons/icn-help.svg"
            :aspect-ratio="undefined"
            class="image-icon ml-2 mb-1"
            height="24"
            width="24"
            contain
          />
        </div>
      </div>
      <div
        v-if="subTitle !== ''"
        class="h-6-bold app-color-purple-light"
      >
        {{ subTitle }}
      </div>
    </div>

    <LineOptions
      v-if="hasOptions"
      v-model="internalCurrent"
      class="d-flex align-center"
      :options="options"
      :optionKey="optionKey"
      :optionLabel="optionLabel"
    />
  </div>
</template>

<script type="text/javascript">
  import dynImage from '@/mixins/utils/dynImage.js'
  import LineOptions from '@/components/ui/common/LineOptions/LineOptions'

  export default {
    components: {
      LineOptions,
    },
    mixins: [dynImage,],
    props: {
      title: {
        type: String,
        default: '',
      },
      category: {
        type: String,
        default: '',
      },
      showHelp: {
        type: Boolean,
        default: false,
      },
      type: {
        type: String,
        default: '',
      },
      subTitle: {
        type: String,
        default: '',
      },
      options: {
        type: Array,
        default: () => {
          return []
        },
      },
      currentOption: {
        type: [String, Number, Boolean, null,],
        default: null,
      },
      optionKey: {
        type: String,
        default: 'key',
      },
      optionLabel: {
        type: String,
        default: 'label',
      },
    },
    computed: {
      titleClass() {
        if (this.type === 'medium') {
          return 'h-3-bold'
        }
        if (this.type === 'small') {
          return 'h-4'
        }

        return 'h-2-bold'
      },
      hasOptions() {
        return this.options && this.options.length > 0
      },
      internalCurrent: {
        get() {
          return this.currentOption
        },
        set(value) {
          return this.$emit('update:currentOption', value)
        },
      },
    },
  }
</script>

<style lang="scss">
.SectionTitle {
  & > div {
    display: inline-block;
  }
}

.SectionTitle-child {
  & > div {
    display: inline-block;
  }

  .category-box {
    height: 40px;
    width: 40px;
    border-radius: 8px;
    background-color: $color-ffffff;
    box-shadow: 0 3px 7px 0 $color-31_54_139_08;
    text-align: center;
    padding-top: 10px;
    margin-right: 16px;

    img {
      width: 16px;
    }
  }

  // .help-box {
  //   width: 24px;
  //   height: 24px;
  //   border-radius: 4.8px;
  //   background-color: $color-161_176_255_16;
  //   color: $color-727efd;
  //   font-weight: bold;
  //   text-align: center;
  //   margin-left: 10px;
  //   position: relative;
  //   bottom: 6px;
  //   cursor: pointer;
  //   vertical-align: sub;
  // }
}
</style>
